import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';

import '@ds/ds-snam';
import '@ds/ds-snam/styles.css';
import '@ds/ds-snam/themes/snam_light_new-theme.css';
import '@ds/ds-snam/themes/snam_dark_new-theme.css';
import { appStore } from 'state/appStore';
import { Provider } from 'react-redux';

import "./i18n";

import { Authenticator } from 'ooAuth2/authenticator';
import { ISsoTokenParams, ISSOToken } from "dataModels/ooauth2";
import { getSSOToken, getUserData } from 'net/ooAuth2';
import { setAxiosHeader } from 'shared/utils/axiosUtils';
import { AppUser } from 'ooAuth2/appUser';
import AppUserContext from 'ooAuth2/appUserContext';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { APP_USER_PROFILES } from 'shared/constants';
import { Avatar } from '@ds/ds-snam/react';
import UnauthorizedPage from 'components/UnauthorizedPage';
import { setPlant } from 'state/reducer/plantSlice';
/**
 * Environment variables from env-config file loaded at runtime
*/
interface Env {
  REACT_APP_HOST_CONTRACTS: string,
  REACT_APP_HOST_B2B: string,
  REACT_APP_HOST_PRE_BILLING: string,
  REACT_APP_HOST_SETTINGS: string,
  REACT_APP_HOST_USER_DATA: string,
  REACT_APP_CLIENT_ID: string,
  REACT_APP_CLIENT_SECRET: string,
  REACT_APP_LOGIN_BASE_URL: string,
  REACT_APP_LOGOUT_BASE_URL: string,
  REACT_APP_SSO_TOKEN_URL: string
}
declare global {
  interface Window {
    _env_: Env;
  }
}
/*=============================================================*/

const appUser: AppUser = new AppUser();
const authenticator: Authenticator = new Authenticator();
let appIsRendered: boolean = false;
let refeshTokenInterval: NodeJS.Timer;

const schedulePolling = () => {
  const jwtToken: JwtPayload = jwtDecode(authenticator.ssoToken?.access_token!);
  //console.log("TOKEN DECRYPTED", jwtToken);
  if (jwtToken && jwtToken.exp) {
    const expires = new Date(jwtToken.exp * 1000);
    const deltaMs = expires.getTime() - (new Date()).getTime();
    //console.log("DELTA seconds:", deltaMs/1000);
    // if I'm 15 seconds before of token expire, get a new token
    if (deltaMs < 15000) {
      clearInterval(refeshTokenInterval);
      const ssoTokenParams: ISsoTokenParams = authenticator.getSSOTokenParams();
      //console.log(authenticator.ssoToken ? "REFRESH TOKEN" : "NEW TOKEN");
      getSSOToken(ssoTokenParams)
        .then((response) => {
          //console.log("GOT NEW TOKEN:", response.data as ISSOToken);
          authenticator.ssoToken = response.data as ISSOToken;
          setAxiosHeader('Authorization', `Bearer ${authenticator.ssoToken.access_token}`);
          refeshTokenInterval = setInterval(schedulePolling, 1000);
        })
        .catch(error => {
          console.log("Error on refreshing token", error);
          //redirect to login ?
        });
    }
  }
}

if (authenticator.code && authenticator.session_state) {
  //console.log("GET SSO");  
  const ssoTokenParams: ISsoTokenParams = authenticator.getSSOTokenParams();
  //console.log(authenticator.ssoToken ? "REFRESH TOKEN" : "NEW TOKEN");
  //console.log("GET TOKEN PARAMS:", ssoTokenParams);
  //get the token
  getSSOToken(ssoTokenParams)
    .then((response) => {
      //console.log("GOT TOKEN:", response.data as ISSOToken);
      authenticator.ssoToken = response.data as ISSOToken;
      setAxiosHeader('Authorization', `Bearer ${authenticator.ssoToken.access_token}`);
      //get user data by verifing token, response include user roles
      return getUserData(authenticator.ssoToken.access_token)
    })
    .then((response) => {
      //console.log(" user data response", response)
      appUser.setData(response.data);
      appUser.userPofile = APP_USER_PROFILES.get(response.data.roles[0])!;
      //console.log(appUser.isAuthenticated)

      //QUI POSSO EDITARE I PLANTS ##########################################
      let myPlants:number[]|undefined = appUser.getPlants();
      if(myPlants!==undefined){
        setAxiosHeader('plantId', myPlants[0].toString());
        appStore.dispatch(setPlant({ plantId: myPlants[0].toString() })); //metto di default il primo plant in elenco
      }

      //End of authentication process, render app and schedule polling to refresh token (first time only)
      if (!appIsRendered) {
        renderApp();
        appIsRendered = true;
        refeshTokenInterval = setInterval(schedulePolling, 1000);
      }
    })
    .catch(error => {
      if (!appIsRendered) {
        renderApp();
        appIsRendered = true;
        refeshTokenInterval = setInterval(schedulePolling, 1000);
      }
      console.log("ERROR ON token or user data call:", error)
    })
}else {
  //console.log("LOGIN")
  authenticator.loginUser();
}

//New: Render app only when all Sso authentication and user are Ok
//To do: if something goes wrong shall I render something else ?
const renderApp = () => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <Provider store={appStore}>
        {appUser.isAuthenticated ?
          <AppUserContext.Provider value={appUser}>
          <App />
        </AppUserContext.Provider>
        :
        <UnauthorizedPage link={''}/>
        }
      </Provider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
